import React, { useEffect, useState } from 'react';
import axios from 'axios';

const VerifyEmailPage = () => {
  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get('token');

    console.log("TOEKN",token)

    if (!token) {
      setStatus('error');
      setMessage('Invalid or missing verification token.');
      return;
    }

    axios
      .post('https://api.bharatdarshan.app/api/auth/verify-email', { token: token })
      .then((res) => {
        setStatus('success');
        setMessage(res.data.message || 'Your email has been successfully verified!');
        console.log("verify email check", res)
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.response?.data?.message || 'Email verification failed. Try again later.');
      });
  }, []);

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        {status === 'verifying' && (
          <>
            <div style={styles.loader}></div>
            <h2 style={styles.heading}>Verifying your email...</h2>
          </>
        )}

        {status === 'success' && (
          <>
            <h2 style={{ ...styles.heading, color: '#4caf50' }}>🎉 Email Verified</h2>
            <p style={styles.message}>{message}</p>
            <a href="/login" style={styles.button}>Go to Login</a>
          </>
        )}

        {status === 'error' && (
          <>
            <h2 style={{ ...styles.heading, color: '#f44336' }}>⚠️ Verification Failed</h2>
            <p style={styles.message}>{message}</p>
            <a href="/login" style={styles.button}>Try Login</a>
          </>
        )}
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f7f7f7',
  },
  card: {
    backgroundColor: '#fff',
    padding: '40px 30px',
    borderRadius: '10px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    textAlign: 'center',
    width: '90%',
    maxWidth: '450px',
    fontFamily: 'Arial, sans-serif',
  },
  heading: {
    fontSize: '24px',
    marginBottom: '15px',
  },
  message: {
    fontSize: '16px',
    marginBottom: '30px',
    color: '#555',
  },
  button: {
    backgroundColor: '#e91e63',
    color: '#fff',
    padding: '12px 25px',
    borderRadius: '5px',
    textDecoration: 'none',
    fontWeight: 'bold',
  },
  loader: {
    border: '4px solid #f3f3f3',
    borderTop: '4px solid #e91e63',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    margin: '0 auto 20px',
    animation: 'spin 1s linear infinite',
  },
};

export default VerifyEmailPage;
